import client from '../../services/session/apiClient';


export function addNote(addNoteRequest) {
  if (!addNoteRequest) throw new Error('cannot add undefined note')
  return client.post('/dashboard/note', addNoteRequest).then(x => x.data)
}

export function updateNote(note) {
  if (!note) throw new Error('cannot update undefined note')
  return client.put('/dashboard/note', note).then(x => x.data)
}
export function getNotes({ ids, noteType, filters = null}) {
  if (ids === undefined || typeof noteType !== 'string') throw new Error('cannot get note without ids and noteType')
  return client.post('/dashboard/note/search', { ids, noteType, filters}).then(x => x.data)
}

export function deleteNote(noteId) {
  if (!noteId) throw new Error('cannot delete note without noteId')
  return client.delete('/dashboard/note/' + noteId).then(x => x.data)
}